/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aicostscolumncost3Inputs */

const en_aicostscolumncost3 = /** @type {(inputs: Aicostscolumncost3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cost`)
};

const de_aicostscolumncost3 = /** @type {(inputs: Aicostscolumncost3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kosten`)
};

/**
* | output |
* | --- |
* | "Cost" |
*
* @param {Aicostscolumncost3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aicostscolumncost3 = /** @type {((inputs?: Aicostscolumncost3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aicostscolumncost3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aicostscolumncost3(inputs)
	return de_aicostscolumncost3(inputs)
});
export { aicostscolumncost3 as "aiCostsColumnCost" }